import { createRouter } from "@tanstack/react-router";
import { PageLoader } from "@/shared/ui/page-loader";
import { NotFoundPage } from "./NotFoundPage";
import { routeTree } from "../routeTree.gen";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultNotFoundComponent: NotFoundPage,
  defaultPendingComponent: PageLoader,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
